import { render, staticRenderFns } from "./GoodsDisplaySetting.vue?vue&type=template&id=0efc6dc8&scoped=true"
import script from "./GoodsDisplaySetting.vue?vue&type=script&lang=js"
export * from "./GoodsDisplaySetting.vue?vue&type=script&lang=js"
import style0 from "./GoodsDisplaySetting.vue?vue&type=style&index=0&id=0efc6dc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc6dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efc6dc8')) {
      api.createRecord('0efc6dc8', component.options)
    } else {
      api.reload('0efc6dc8', component.options)
    }
    module.hot.accept("./GoodsDisplaySetting.vue?vue&type=template&id=0efc6dc8&scoped=true", function () {
      api.rerender('0efc6dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/member/goods/GoodsDisplaySetting.vue"
export default component.exports